export default "__VITE_ASSET__BhwhU8XW__"